module.exports = __webpack_public_path__ + "static/media/document-placeholder.cc833c08.svg";